var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { Input } from '.';
import { useInput } from './useInput';
/**
 * # SearchInput
 *
 * 검색 인풋 컴포넌트.
 *
 * @param {SearchInputProps} {@link SearchInputProps} 검색 인풋 파라미터
 *
 * @example ```tsx
 * <SearchInput size='small' placeholder='search...' />
 * <SearchInput size='small' placeholder='search...' disabled />
 * ```
 */
export var SearchInput = function (props) {
    var _a = useInput(props), _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, placeholder = _a.placeholder, value = _a.value, onChange = _a.onChange, onReset = _a.onReset;
    return (<Input size={size} disabled={disabled} placeholder={placeholder} value={value} onChange={onChange} prefix={<svg viewBox='0 0 24 24' width='18' height='18' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' fill='none' shapeRendering='geometricPrecision'>
          <path d='M11 17.25a6.25 6.25 0 110-12.5 6.25 6.25 0 010 12.5z'/>
          <path d='M16 16l4.5 4.5'/>
        </svg>} suffix={value.length > 0 && (<RemoveText onClick={function () { return (onReset ? onReset() : onChange('')); }}>
            <svg viewBox='0 0 24 24' width='18' height='18' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' fill='none' shapeRendering='geometricPrecision'>
              <path d='M21 4H8l-7 8 7 8h13a2 2 0 002-2V6a2 2 0 00-2-2z'/>
              <path d='M18 9l-6 6'/>
              <path d='M12 9l6 6'/>
            </svg>
          </RemoveText>)} prefixStyling={false} suffixStyling={false}/>);
};
var RemoveText = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var templateObject_1;
//# sourceMappingURL=SearchInput.jsx.map